<template>
    <div class="dicom-analysis-panel">
        <div class="dicom-analysis-settings">
            <li class="list-group-item dicom-setting-item active">Settings</li>
            <li class="list-group-item dicom-setting-item">
                <label class="dicom-ctrl mt-1">
                    <span class="dicom-check-label">Show segmentations:</span>
                    <input type="checkbox" class="dicom-check-input" v-model="showSegmentations"
                        @change="showSegmentationsChanged()">
                </label>
                <label class="dicom-ctrl mt-1">
                    <span class="dicom-check-label">Show landmarks:</span>
                    <input type="checkbox" class="dicom-check-input" v-model="showLandmarks"
                        @change="showLandmarksChanged()">
                </label>
                <label class="dicom-ctrl mt-1">
                    <span class="dicom-check-label">Show labels:</span>
                    <input type="checkbox" class="dicom-check-input" v-model="showLabels" @change="showLabelsChanged()">
                </label>
                <!-- <div class="dicom-ctrl mt-1">
                    <span class="dicom-check-label">Opacity:</span>
                    <input type="range" class="dicom-slider-input" v-model="opacity.value" :min="opacity.min"
                        :max="opacity.max" :step="opacity.step" @mouseup="opacityChanged()">
                </div> -->
            </li>
        </div>
        <!-- <button type="button" class="btn btn-primary btn-sm btn-block dicom-add-btn" v-on:click="addLandmarkClick">Add
            Landmark
        </button> -->
        <div class="dicom-landmarks-list" ref="dicomLandmarksList"></div>
        <button type="button" class="btn btn-primary btn-sm btn-block dicom-exit-btn" v-on:click="close">Exit
            3D Analysis</button>
    </div>
</template>

<script>
import { hexToCanvasColor } from "../annotation";
import {
    leaveAnalysisMode, switchLandmarksVisible,
    switchLabelsVisible,
} from "./AnalysisManager";

import {
    addLandmark
} from "./AnalysisManager";

export default {
    name: "AnalysisListPanel",
    data() {
        return {
            showLandmarks: true,
            showLabels: true,
            showSegmentations: true,
            opacity: {
                value: 0.5,
                min: 0.2,
                max: 0.8,
                step: 0.01,
                default: 0.5
            },
        }
    },
    props: {
        app: {
            type: Object,
            required: false
        }
    },
    mounted() {
        this.app.lpanelId = `${this.app.orientation}_lpanel`;
        this.$refs.dicomLandmarksList.setAttribute("id", this.app.lpanelId);
    },
    methods: {
        addLandmarkClick: function () {
            addLandmark();
        },
        showSegmentationsChanged: function () {
        },
        showLandmarksChanged: function () {
            // this.showLandmarks = !this.showLandmarks;
            switchLandmarksVisible(this.showLabels, this.showLandmarks);
        },
        showLabelsChanged: function () {
            // this.showLabels = !this.showLabels;
            switchLabelsVisible(this.showLabels, this.showLandmarks);
        },
        close: function () {
            console.log("close analysisListPanel");
            leaveAnalysisMode();
        },
    }
}

</script>

<style scoped>
.dicom-analysis-panel {
    height: 100%;
    width: 100%;
    background-color: black;
}

.dicom-analysis-settings {
    /* background-color: orange; */
    /* height: 130px; */
    width: calc(100% - 5px);
}

.dicom-add-btn {
    margin: 2px 5px 8px 5px;
    width: calc(100% - 15px);
    /* padding: 0; */
}

.dicom-landmarks-list {
    /* background-color: green; */
    overflow-y: scroll;
    width: 100%;
    height: calc(100% - 170px);
}

.dicom-exit-btn {
    margin: 8px 5px 0 5px;
    width: calc(100% - 15px);
    /* padding: 0; */
}

.dicom-setting-item {
    text-align: left;
    padding: .3rem .4rem;
}

.dicom-setting-btn {
    margin: 5px 0;
    padding: 0;
}

.dicom-ctrl {
    text-align: left;
    display: block;
    white-space: nowrap;
    margin: 0;
}

.dicom-check-label {
    margin-right: 0.5rem;
    vertical-align: middle;
}

.dicom-check-input {
    /* margin-top: 20px; */
    vertical-align: middle;
}

.dicom-slider-input {
    /* margin-top: 20px; */
    vertical-align: middle;
    width: calc(100% - 65px);
}

::-webkit-scrollbar {
    width: 5px;
}

::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px transparent;
    border-radius: 10px;
}

::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
    background: #007bff;
}
</style>